export default __webpack_public_path__ + "static/media/s4_female.5e4e1a82.wav";